module.exports = __webpack_public_path__ + "static/NhiLe-42a20db455ca242b0ed9e7910e6f1b16.svg";